import request from "@/utils/request";

// 列表
export function C_cartList(data) {
  return request({
    url: `/api/business/C_cart/getList`,
    method: "post",
    data: data,
  });
}
// 创建
export function setC_cartList(data) {
  return request({
    url: `/api/business/C_cart`,
    method: "post",
    data: data,
  });
}
// 删除
export function batchRemove(id) {
  return request({
    url: `/api/business/C_cart/${id}`,
    method: "delete",
  });
}
// 批量删除
export function batchRemoves(id) {
  return request({
    url: `/api/business/C_cart/batchRemove/${id}`,
    method: "delete",
  });
}
// 更新
export function updataList(id,data) {
  return request({
    url: `/api/business/C_cart/${id}`,
    method: "put",
    data
  });
}
